// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  clientId: '44d3bacb-7c7a-404f-b5bb-174efbf8c19b',
  tenantId: '9c901a7a-a846-4962-94d8-deb98f963564'
};
